export default __webpack_public_path__ + "static/media/twitter.04c9b836.png";